<template>
  <div>

    <CRow>
      <CCol col="3">
        <CSelect
            :label="$t('fromInventory')"
            :options="place_items"
            :value.sync="selected_place_from"

        />
      </CCol>
      <CCol col="3">
        <CSelect
            :label="$t('toInventory')"
            :options="place_items"
            :value.sync="selected_place_to"

        />
      </CCol>
      <CCol col="2">
        <CInput

            v-on:keypress="isEnglish($event)"
            v-model="product_location"
            :label="$t('productLocation')"
        />
      </CCol>
      <CCol col="4">
        <CInput
            :label="$t('tables.summary')"
            v-model="summary"

        />
      </CCol>


    </CRow>
    <hr>
    <CRow>
      <CCol col="3">
        <CSelect
            :options="category_items"
            :label="$t('components.productCategory')"
            :value.sync="selected_category"
            horizontal
        />
      </CCol>
      <CCol col="3">
        <CRow style="padding-right: 7px;padding-left:7px">
          <CCol col="10" class="m-0 p-0">
            <treeselect v-if="selected_category==0 && status_form==0"
                        v-model="selected_product"
                        ref="product_searcher"
                        id="product_seeker"
                        :async="true"
                        :appendToBody="true"
                        @select="select_product"
                        :load-options="load_products"
                        :placeholder="$t('searchItem')"
                        :normalizer="normalizer_products"
            />
            <label v-if="status_form!=0">{{ product_name }}</label>
          </CCol>
          <CCol col="2" class="m-0 p-0">
            <CButton style="height: 100%;" v-if="selected_product!=null" size="sm" outline color="dark"
                     @click="open_selected_product()">
              <CIcon size="sm" name="cil-cart"/>
            </CButton>

          </CCol>
        </CRow>

      </CCol>
      <CCol col="2">
        <CInputCurrency v-if="selected_category==0"
                        v-model="product_qty"
                        v-on:keyup.enter="insert_product()"
                        id="product_qty"
                        :placeholder="$t('tables.qty')"
        />
      </CCol>
      <CCol col="2">
        <p v-if="selected_category==0 && product_exsistance>0">
          {{ $t('SaleableQty') }}: {{ product_exsistance }}
        </p>
        <p class="text-danger" v-if="selected_category==0 && product_exsistance<=0">
          {{ $t('SaleableQty') }}: {{ product_exsistance }}
        </p>
      </CCol>
      <CCol col="2">
        <CButton v-if="status_form==0" size="sm" @click="insert_product" color="dark">
          <CIcon name="cil-plus" size="sm"/>
        </CButton>
        <CButton v-if="status_form!=0" size="sm" @click="edit_product" color="dark">
          <CIcon name="cil-plus" size="sm"/>
        </CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="6">
        <CDataTable
            :items="transfer_product_inventory_items"
            :fields="transfer_product_inventory_fields"
            striped
            border
            :items-per-page="200"
            hover
            pagination
        >


          <template #summary="{item}">
            <td>
              <strong>{{ item.docDesc }}</strong>
            </td>
          </template>
          <template #row="{item,index}">
            <td>
              <strong>{{ index + 1 }}</strong>
            </td>
          </template>
          <template #operation="{item,index}">
            <td>


              <CIcon class="text-danger mr-1" @click.native="delete_item_dialog(item,index)"
                     name="cil-trash"/>

              <CIcon class="text-primary mr-1" @click.native="edit_item(item)"
                     name="cil-pencil"/>

            </td>
          </template>

        </CDataTable>

      </CCol>
    </CRow>
    <CButton @click="insert_data()" type="submit" size="sm" color="secondary">
      {{ $t('addTransferInventory') }}
    </CButton>


  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      place_items: [],
      selected_place_from: 0,
      selected_place_to: 0,
      product_qty: '',
      product_name: '',
      selected_product: null,
      product_location: '',
      category_items: [],
      selected_category: 0,
      change_status_modal: false,
      summary: '',
      start_date: '',
      end_date: '',
      selected_factor: {},
      template_products: [],
      search_factor_text: null,
      selected_factors_for_status: [],
      selected_status: 0,
      product_exsistance: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('inDriver'), value: 25}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      selected_type: 1,
      transfer_product_inventory_items: [],
      transfer_product_inventory_fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'ProductName', label: this.$t('tables.name'), _style: 'width:50%;'},

        {key: 'Qty', label: this.$t('tables.qty'), _style: 'width:10%'},
        {key: 'Existence', label: this.$t('SaleableQty'), _style: 'width:10%'},

        {key: 'operation', label: '', _style: 'width:20%;'},
      ],
      status_form: 0,
      refer_messages: [],
      selected_factor_id: 0,
      check_all_exit: false,
      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },

      normalizer_factors(node) {
        return {
          id: node.recId,
          label: node.masterCode + " " + node.partyName,
        }
      },
    }
  },
  mounted() {
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_places()
    this.get_categories()
    this.get_messages();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.return_items();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'product_location': function () {
      this.product_location = this.product_location.toUpperCase();
    },
    'selected_category': function () {
      this.transfer_product_inventory_items = [];
      this.get_products();
    },
    'end_date': function () {
      // this.get_all_data();
    },
    'selected_type': function () {
      this.search_factor_text = null;
      this.transfer_product_inventory_items = [];
      this.selected_factor = {};
    },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.transfer_product_inventory_items.forEach((val) => {
          this.id_checkbox_items.push(val.recId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },

  },
  methods: {
    open_selected_product() {
      window.open('/dashboard/products/edit/' + this.selected_product, '_blank')
    },
    get_categories() {
      var self = this;

      var formData = new FormData();

      axios.post('GetAllCats', formData, {}).then(function (response) {

        var content_cats = response.data;

        // items = content_cats.orders;
        self.category_items.push({label: self.$t('dialogs.insertCategory'), value: 0})
        // self.category_items.push({label: self.$t('all'), value: -1})
        self.category_items = self.sort_array(self.category_items, content_cats.data, "catRelId", "catTitle");


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item, index) {
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      // this.status_product_form = item.row_id;
      this.transfer_product_inventory_items.splice(index, 1)
    },
    insert_product() {

      if (this.template_products.length > 0) {
        for (var i = 0; i < this.template_products.length; i++) {
          this.transfer_product_inventory_items.push({
            ProductId: this.template_products[i].productId,
            ProductName: this.template_products[i].productName,
            Existence: this.template_products[i].existance,
            Qty: this.template_products[i].existance
          })
        }
        this.template_products = [];
        return;
      }
      if (this.product_exsistance == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('noExistence')])
        return
      }
      if (this.product_qty > this.product_exsistance) {
        this.$root.modal_component.show_validate_errors([this.$t('qtyLargerExistence')])
        return;
      }
      if (this.status_form != 0) {
        this.edit_product();
        return;
      }
      if (this.selected_product != null && this.product_qty != '0' && this.product_qty != '') {
        this.transfer_product_inventory_items.push({
          ProductId: this.selected_product,
          ProductName: this.product_name,
          Existence: this.product_exsistance,
          Qty: this.product_qty
        })
        this.selected_product = null;
        this.product_qty = '';
      }
    },
    edit_product() {
      this.transfer_product_inventory_items.filter(x => x.ProductId == this.status_form)[0].Qty = this.product_qty;
      this.status_form = 0;
      this.selected_product = null;
      this.product_qty = "";
      this.product_exsistance = "";

    },
    select_product(node, instance) {
      var self = this;
      console.log("node is", node)
      this.product_name = node.productName;
      // this.product_existance = node.existence;
      // this.product_price = node.salePrice;
      // this.product_weight = node.weight;
      // this.product_off = node.takhfif;
      // this.product_tax = node.vat;
      // this.product_off_is_percent = node.isPercent;
      // this.product_unit = node.productUnitId;
      // this.product_unit_name = node.productUnitName;
      // this.product_unit_value = node.value;
      setTimeout(function () {
        document.getElementById('product_qty').select();
        self.get_products();

      }, 150);
    },
    get_places() {
      var self = this;

      const formData = new FormData();

      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.place_items = [];
          self.place_items = self.sort_array(
              self.place_items, content_data.data,
              'id', 'placeName');
          self.selected_place_from = self.place_items[0].value
          self.selected_place_to = self.place_items[0].value
          self.get_all_data();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_products() {
      var self = this;

      const formData = new FormData();

      if (this.selected_category == 0) {
        if (this.selected_product == null) {
          return
        }
        formData.append("ProductId", this.selected_product);
        formData.append("CatId", 0);
      } else {
        formData.append("ProductId", 0);
        formData.append("CatId", this.selected_category);
      }
      formData.append("PlaceId", this.selected_place_from);
      axios.post('GetProductExistance', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (self.selected_category == 0) {
            self.product_exsistance = content_data.data[0].existance
          } else {
            self.template_products = content_data.data
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    load_factors({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var self = this;


          const formData = new FormData();

          var url = "GetDocsByParams";
          formData.append("docType", this.selected_type);
          formData.append("PersonId", 0);

          // formData.append("id", 3);
          formData.append("SearchTxt", searchQuery);
          formData.append("FirstDate", self.start_date);
          formData.append("SecondDate", self.end_date);

          axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              options = response.data.data;

              callback(null, options);

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }

          })
              .catch(function (error) {

                console.log(error);
              });
        })
      }
    },
    select_factor(node) {
      console.log("node ", node)
      this.factor_party_name = node.partyName;
      this.factor_date = this.get_date(node.createdAt)
      this.selected_factor_id = node.recId;
      this.selected_factor = node;
      if (node.statusId == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('documentIsNotFinalize')])
      } else {
        this.get_document_details();

      }
    },
    get_damage_products() {
      var self = this;

      this.id_checkbox_items = [];
      const formData = new FormData();

      var url = "GetDamageProducts";

      // formData.append("id", this.selected_factor_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.damage_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_messages() {
      var self = this;
      const formData = new FormData();

      var url = "GetFactorReferMessages";

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.refer_messages = self.sort_array([], content_data.data, "id", 'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },


    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },

    get_all_data() {
      this.get_damage_products();
      // this.get_exit_products();
      // this.get_insite_lists()
      // this.get_delivery_lists()
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      console.log("edit", item);
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.selected_product = item.ProductId;
      this.product_exsistance = item.Existence;
      this.product_name = item.ProductName;
      this.product_qty = item.Qty;
      this.status_form = item.ProductId;

    },
    emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (this.transfer_product_inventory_items.length == 0) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      url = "AddFactorMove";

      formData.append('Shelf', this.product_location);
      formData.append('SourcePlaceId', this.selected_place_from);
      formData.append('DestinationPlaceId', this.selected_place_to);
      formData.append('Details', JSON.stringify(this.transfer_product_inventory_items));
      formData.append('Summary', this.summary);
      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.transfer_product_inventory_items = [];
        }


      }).catch(function (error) {
        console.log(error);
      });

    },
    confirm_dialog() {
      if (this.id_checkbox_items.length == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
        return false;
      }
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturn"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.change_status_modal = true;

    },
  }
}

</script>
